/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Autocomplete, Button, Card, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, } from "@mui/material";
import axios from "axios";
import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { addItemsData, getCurrencyCode, getItemsById, updateItemsData } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import PageTitle from "examples/PageTitle/PageTitle";
import { formatNumberWithCommas } from "utils/formatCurrency";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
let SCREEN_RIGHT;
let fetchedItems;
let routePath = "";
let paramID = undefined; let paramValue = undefined;
let source = undefined; let eID = undefined;

function AddItemCategory() {
  const { id } = useParams();
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const [screenName, setScreenName] = useState("Add New Item");
  const [disableColor, setDisableColor] = useState(false);
  const [categoryErr, setCategoryErr] = useState(false);
  const [itemNameErr, setItemNameErr] = useState(false);
  const [itemCodeErr, setItemCodeErr] = useState(false);
  // const [unitOfMeasurementErr, setUnitOfMeasurementErr] = useState(false);
  const [itemStatusErr, setItemStatusErr] = useState(false);
  const [itemPriceErr, setItemPriceErr] = useState(false);
  const [itemQuantityErr, setItemQuantityErr] = useState(false);
  const [gstErr, setGSTErr] = useState(false);
  const [itemCategoriesName, setItemCategoriesName] = useState([]);
  const [parameterValues, setparameterValues] = useState([]);
  const [currencyCode, setCurrencyCode] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [routePath, setRoutePath] = useState("");
  const [paramID, setParamID] = useState("");
  const [source, setSource] = useState("");

  const [values, setValues] = useState({
    categoryName: "",

    categoryID: "",
    itemName: "",
    itemCode: "",
    itemDescription: "",
    itemStatus: "Active",
    unitOfMeasurement: "",
    itemPrice: "",
    itemQuantity: "",
    gst: "",
    discountType: "None",
    discountValue: "",
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID
  });

  // useEffect(() => {

  //   paramID = new URLSearchParams(window.location.search).get('id');
  //   if (paramValue = new URLSearchParams(window.location.search).get('new')) {
  //     switch (paramValue) {
  //       case "rcti":
  //         routePath = `/rcti/edit/${paramID}`;
  //         break;
  //       case "invoice":
  //         routePath = `/invoices/edit/${paramID}`;
  //         break;
  //       case "quotation":
  //         routePath = `/quotations/edit/${paramID}`;
  //         break;
  //       default:
  //         routePath = `/items`;
  //         break;
  //     }
  //   } else {
  //     source = new URLSearchParams(window.location.search).get('source');
  //     switch (source) {
  //       case "rcti":
  //         routePath = `/rcti/edit/${paramID}`;
  //         break;
  //       case "invoice":
  //         routePath = `/invoices/edit/${paramID}`;
  //         break;
  //       case "quotation":
  //         routePath = `/quotations/edit/${paramID}`;
  //         break;
  //       default:
  //         routePath = `/items`;
  //         break;
  //     }
  //   }

  //   id === undefined ? setScreenName("Add New Item") : setScreenName("Edit Item");
  //   (async () => {
  //     fetchCategories();
  //     fetchParameterValue();
  //     fetchCurrencyValue();
  //     getRight();
  //     if (id !== undefined) {
  //       values._id = id
  //       getItemsById({ _id: id }, (data) => {
  //         if (data.Result_Output.length > 0) {
  //           fetchedItems = data.Result_Output[0];
  //           setValues(fetchedItems);
  //         }
  //       }, dispatch)
  //     }
  //   }
  //   )();
  // }, [dispatch])



  /** 🔹 1. INIT EFFECT */
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const idParam = params.get("id");
    const newParam = params.get("new");
    const sourceParam = params.get("source");

    setParamID(idParam);
    setSource(sourceParam);

    const type = newParam || sourceParam;

    let path = "/items";

    switch (type) {
      case "rcti":
        path = `/rcti/edit/${idParam}`;
        break;
      case "invoice":
        path = `/invoices/edit/${idParam}`;
        break;
      case "quotation":
        path = `/quotations/edit/${idParam}`;
        break;
      default:
        path = "/items";
    }

    setRoutePath(path);

    setScreenName(id ? "Edit Item" : "Add New Item");

    fetchCategories();
    fetchCurrencyValue();
    getRight();

  }, [id, dispatch]);

  useEffect(() => {
    fetchParameterValue();
  }, []);

  const fetchParameterValue = async () => {
    try {
      const res = await axios.post(appConstants.baseURL + "items/fetchParameterValue");

      const response = res.data.Result_Output[0].list;
      setparameterValues(response);

      const defaultValue = response.find(item => item.customValue1 === "10")?._id;

      if (defaultValue) {
        setValues(prev => ({
          ...prev,
          gst: prev.gst || defaultValue // 🔥 don't overwrite if already set
        }));
      }

    } catch (error) {
      console.log("Error in Fetching Parameter", error.message);
    }
  };

  const handleNewChange = (name) => (event, newValue) => {
    if (newValue) {
      if (newValue.value === 'add-new') {
        navigate(`/itemCategory/addItemCategory?new=item${paramID ? `&for=${paramValue}&id=${paramID}` : ''}`);
      } else {
        setValues({ ...values, [name]: newValue.label, categoryID: newValue.value });
      }
    } else {
      if (event && event.target && event.target.validity !== undefined && event.target.validity.valid === true) {
        setValues({ ...values, [name]: event.target.value });
      } else if (event && event.target && event.target.validity === undefined) {
        setValues({ ...values, [name]: event.target.value });
      }
    }
  };


  const handleChange = (name) => (event) => {
    let inputValue = event.target.value;

    if (name === 'itemPrice' || name === 'discountValue' || name === 'itemQuantity') {

      if (name === 'itemPrice') {
        let value = event.target.value.replace(/,/g, ""); // remove commas for validation

        // allow typing "." at start
        if (value === ".") value = "0.";

        // allow empty value (so user can erase)
        if (value === "") {
          setValues({ ...values, [name]: "" });
          return;
        }

        // validate up to 2 decimals, max 7 digits before decimal
        const regex = /^\d{0,7}(\.\d{0,2})?$/;
        if (regex.test(value)) {
          setValues({ ...values, [name]: value });
        }
      }

      if (inputValue === '.') {
        inputValue = '0.';
      }
      const regex = /^\d{1,7}(?:\.\d{0,2})?$/;
      if (regex.test(inputValue) || inputValue === "") {
        if (name === 'itemPrice' || name === 'itemQuantity') setValues({ ...values, [name]: inputValue });
        else if (name === 'discountValue') {
          const VALUE = inputValue !== "" ? parseFloat(inputValue) : "";
          if (values.discountType === "Percentage") {

            if (VALUE < 100 || VALUE === "") {
              setValues({ ...values, [name]: VALUE });
            } else {
              showResMsg("Discount value should be less than 100", 1000, false);
            }
          }
          else if (values.discountType === "Fixed") {
            let totalPrice = parseFloat(values.itemPrice) * parseFloat(values.itemQuantity);
            if (VALUE < totalPrice || VALUE === "") {
              setValues({ ...values, [name]: VALUE });
            } else {
              showResMsg("Discount must be lower than the total price or non-zero.", 1000, false);
            }
          }
        }
      }
    }

    // else if (name === "priceValidityValue") {
    //   const VALUE = inputValue !== "" ? parseInt(inputValue) : "";
    //   const regex = /^\d{1,3}$/;
    //   if (regex.test(VALUE) || VALUE === "") {
    //     setValues({ ...values, [name]: VALUE });
    //   }
    // }

    // else if (name === "priceValidity" && inputValue === "None") {
    //   setValues({ ...values, [name]: inputValue, priceValidityValue: 0 });
    // }
    else if (name === "discountType" && inputValue === "None") {
      setValues({ ...values, [name]: inputValue, discountValue: 0 });
    }
    else {
      if (event.target.validity && event.target.validity.valid) {
        setValues({ ...values, [name]: inputValue });
      }
      else if (event.target.validity === undefined) {
        setValues({ ...values, [name]: inputValue });
      }
    }
  };




  async function getRight() {
    let right = await getScreenRight("Items")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)
  }

  let fetchCategories = async () => {

    await axios
      .post(appConstants.baseURL + "items/fetchCategoriesData", { businessUserID: values.businessUserID })
      .then(
        (res) => {
          let response = res.data.fetchCategories;
          console.log("response", response)
          setItemCategoriesName(response);
        })
      .catch(
        (error) => {
          console.log("Error in Fetching", error.message)
        }
      )
  }

  useEffect(() => {
    if (!id) return;

    getItemsById(
      { _id: id },
      (data) => {
        if (data?.Result_Output?.length > 0) {
          const fetchedItems = data.Result_Output[0];

          setValues(prev => ({
            ...prev,
            ...fetchedItems
          }));
        }
      },
      dispatch
    );

  }, [id, dispatch]);


  let fetchCurrencyValue = async () => {
    await getCurrencyCode({ businessUserID: values.businessUserID }, (data => {
      if (data.Result_Status) {
        setCurrencyCode(data.Result_Output)
      }
    }), dispatch);
  }

  const clearErrorStates = () => {
    setItemNameErr(false);
    setItemCodeErr(false);
    // setUnitOfMeasurementErr(false);
    setItemStatusErr(false);
    setCategoryErr(false);
    setItemPriceErr(false);
    setItemQuantityErr(false);
    setGSTErr(false);
  };

  const handleAddData = async () => {
    if (!values.discountValue) {
      values.discountValue = 0;
    }
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.itemName, setItemNameErr) || mandateFlag;
    mandateFlag = validateField(values.itemCode, setItemCodeErr) || mandateFlag;
    mandateFlag = validateField(values.itemPrice, setItemPriceErr) || mandateFlag;
    mandateFlag = validateField(values.itemStatus, setItemStatusErr) || mandateFlag;
    mandateFlag = validateField(values.categoryName, setCategoryErr) || mandateFlag;
    mandateFlag = validateField(values.gst, setGSTErr) || mandateFlag;
    mandateFlag = validateField(values.itemQuantity, setItemQuantityErr) || mandateFlag;
    // mandateFlag = validateField(values.unitOfMeasurement, setUnitOfMeasurementErr) || mandateFlag;
    const payload = {
      ...values,
      source,
      sourceID: paramID,
      businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID
    };
    if (mandateFlag) {
      return;
    }

    const apiFunction = id === undefined ? addItemsData : updateItemsData;
    values.businessUserID = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID;
    apiFunction(payload, (data) => {
      if (data.Result_Status) {
        console.log("data", data);
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, `${routePath}?item=${data.Result_Output?._id}`);
        // showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, `${routePath}`);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };
  const GSTLIST = parameterValues.map((item, index) => (
    <MenuItem key={index} value={item._id}>{item.parameterListName}</MenuItem>
  ))

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card sx={{ boxShadow: "none" }}>
          <PageTitle screenName={screenName} />
          <MDBox mt={1.8} mb={0.8}>
            <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
              <Grid item lg={12} xs={12}>

                <MDBox>
                  <Grid container px={2} py={2} spacing={3}>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Item Code"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 50,
                          pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                          className: "custom-fieldtext"
                        }}
                        value={values.itemCode}
                        onChange={handleChange("itemCode")}
                      />
                      {itemCodeErr ? <span style={errMsg}>Item Code can't be blank</span> : ""}
                    </Grid>


                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Item Name"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 200,
                          pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                          className: "custom-fieldtext"
                        }}
                        value={values.itemName}
                        onChange={handleNewChange("itemName")} />
                      {itemNameErr ? <span style={errMsg}>Item Name can't be blank</span> : ""}

                    </Grid>

                    <Grid item lg={4} xs={12} >
                      <Autocomplete


                        sx={{ height: "35.11px", }}
                        id="categoryName-select"

                        options={[
                          // { label: 'Add New Account', value: 'add-new' },
                          ...itemCategoriesName.map(category => ({
                            label: `${category.categoryCode} - ${category.categoryName}`, value: category._id
                          }))
                        ]}
                        renderOption={(props, option) => (
                          <li {...props} key={option.value}
                            // className={option.value === 'add-new' ? 'dropDownDefaultHighlight' : 'autoCompleteList'}
                            className={
                              darkMode ? `autoCompleteDarkList` : `autoCompleteList`
                            }

                          >
                            {option.label}
                          </li>
                        )}
                        filterOptions={(options, state) => {
                          const filtered = options.filter(option =>
                            option.label.toLowerCase().includes(state.inputValue.toLowerCase())
                          );

                          return filtered;
                        }}
                        onChange={handleNewChange("categoryName")}
                        value={values.categoryName}
                        renderInput={(params) =>
                          <TextField {...params} className="ress" label="Account" placeholder="Account"
                            variant="outlined"
                            style={{ height: "35.11px", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            autoFocus={true} sx={{ paddingBottom: '6px' }} />}
                      // disabled={id}
                      />
                      {categoryErr ? <span style={errMsg}>Please select Account value</span> : ""}
                    </Grid>

                    <Grid item lg={8} xs={12}>
                      <TextField
                        id="description"
                        label={values.itemDescription.toString().length > 0 ? `Description (${values.itemDescription.toString().length}/300)` : "Description"}
                        multiline
                        style={{ width: "100%" }}
                        // rows={2}
                        variant="outlined"
                        value={values.itemDescription}
                        onChange={handleChange("itemDescription")}
                        inputProps={{ maxLength: 300, className: "descriptiontext" }}
                      />
                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ height: "35.11px" }}
                          label="Status"
                          onChange={handleChange("itemStatus")}
                          value={values.itemStatus}
                        >
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                        {itemStatusErr ? <span style={errMsg}>Status can't be blank</span> : ""}
                      </FormControl>
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Unit Of Measurement(optional)</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ height: "35.11px" }}
                          label="Unit Of Measurement(optional)"
                          placeholder="Unit Of Measurement(optional)"
                          onChange={handleChange("unitOfMeasurement")}
                          value={values.unitOfMeasurement}
                        >
                          <MenuItem value="">None</MenuItem>
                          <MenuItem value="Meter">meter</MenuItem>
                          <MenuItem value="Piece">piece</MenuItem>
                          <MenuItem value="Kg.">kg</MenuItem>
                          <MenuItem value="MM">mm</MenuItem>
                          <MenuItem value="Litre">litre</MenuItem>
                        </Select>
                      </FormControl>

                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label={`Unit Price (${currencyCode})`}
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 8,
                          pattern: "^[0-9.]+$",
                          className: "custom-fieldtext"
                        }}
                        value={formatNumberWithCommas(values.itemPrice)}
                        onChange={handleChange("itemPrice")} />
                      {itemPriceErr ? <span style={errMsg}>Unit Price can't be blank</span> : ""}
                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <TextField
                        type="text"
                        label="Default Quantity"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 5,
                          pattern: "^[0-9]+$",
                          className: "custom-fieldtext"
                        }}
                        value={values.itemQuantity}
                        onChange={handleChange("itemQuantity")}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, "");
                        }}
                      />
                      {itemQuantityErr ? <span style={errMsg}>Default Quantity can't be blank</span> : ""}
                    </Grid>

                    <Grid item lg={4} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">GST (%)</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={values.gst}
                          label="GST (%)"

                          sx={{ height: "35.11px" }}
                          placeholder="GST"


                          onChange={handleChange("gst")}
                        >
                          {GSTLIST}
                        </Select>
                      </FormControl>
                      {gstErr ? <span style={errMsg}>Please select GST value</span> : ""}

                    </Grid>

                    <Grid item lg={2} xs={6}>
                      <FormControl fullWidth>
                        <InputLabel id="discountType-select-label">Discount Type</InputLabel>
                        <Select
                          label="Discount Type"
                          labelId="discountType-select-label"
                          id="discountType-select"
                          style={{ height: "35.11px" }}
                          onChange={handleChange("discountType")}
                          value={values.discountType}
                        >
                          <MenuItem value="None">None</MenuItem>
                          <MenuItem value="Percentage">Percentage %</MenuItem>
                          <MenuItem value="Fixed">Fixed</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item lg={2} xs={6} mb={1.8}>
                      <TextField
                        type="text"
                        label={values.discountType === "None" ? "Discount Value" : values.discountType === "Percentage" ? `Discount Value (%)` : `Discount Value (${currencyCode})`}
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 5,
                          pattern: "^[0-9.]+$",
                          className: "custom-fieldtext"
                        }}
                        InputLabelProps={{ shrink: true }}
                        placeholder="0"
                        disabled={values.discountType === "None" ? true : false}
                        value={values.discountValue}
                        onChange={handleChange("discountValue")} />
                    </Grid>
                  </Grid>
                </MDBox>
                <Grid
                  container
                  pb={3}
                  columnSpacing={4}
                  alignItems="center"
                  display="flex"
                  justifyContent="center"
                >
                  <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                    <Link to={routePath}>
                      <MDButton
                        className="btn-block center-container-btn btn-warning btn-back rightSpace"
                        color="warning"
                        fullWidth
                      >
                        Close
                      </MDButton>
                    </Link>
                  </Grid>
                  <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                    <MDButton
                      rel="noreferrer"
                      variant="gradient"
                      color="success"
                      fullWidth
                      onClick={handleAddData}
                      disabled={SCREEN_RIGHT === "View Only"}
                    >
                      {id ? "Update" : "Save"}

                    </MDButton>
                  </Grid>
                </Grid>

                {/* </Card> */}
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </div>

    </DashboardLayout>
  );
}

export default AddItemCategory;
